import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthed } from "../utils/auth";
import useCurrentUser from "../hooks/useCurrentUser";

const GUEST_ALLOWED_PATHS = ["/model-zoo", "/qm-blueprint", "/landing-page"];

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const { user, loading } = useCurrentUser();

  if (!isAuthed()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Wait for user info before enforcing guest restriction
  if (
    !loading &&
    user?.user_type === "guest" &&
    !GUEST_ALLOWED_PATHS.includes(location.pathname)
  ) {
    return <Navigate to="/landing-page" replace />;
  }

  return children;
}
